import React from 'react';
import useSectionView from '../../hooks/useSectionView';

const FEATURES = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--signal)' }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <line x1="8" y1="7" x2="16" y2="7" />
        <line x1="8" y1="12" x2="10" y2="12" />
        <line x1="14" y1="12" x2="16" y2="12" />
        <line x1="8" y1="16" x2="10" y2="16" />
        <line x1="14" y1="16" x2="16" y2="16" />
      </svg>
    ),
    name: 'Tax reserve calculator',
    desc: 'Know what to set aside every quarter. SE tax, federal, and state — all estimated into your recommended quarterly reserve.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--signal)' }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 8 14 12 10 9 6 13" />
        <line x1="4" y1="20" x2="20" y2="20" />
        <line x1="4" y1="20" x2="4" y2="4" />
      </svg>
    ),
    name: '90-day cash flow projection',
    desc: 'See slow months coming before they hit your bank account.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--signal)' }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12 C5 6 8 6 9 12 C10 18 13 18 15 12 C17 6 20 6 21 12" />
      </svg>
    ),
    name: 'Income curve adjuster',
    desc: 'Map your hail season so projections match how you actually earn — big spring and summer, slow winter.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--signal)' }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
        <line x1="6" y1="15" x2="9" y2="15" />
      </svg>
    ),
    name: 'IRS Direct Pay walkthrough',
    desc: 'Step-by-step guide from your tax reserve to a paid quarterly payment.',
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--signal)' }} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16l4-2 4 2 4-2 4 2V8z" />
        <line x1="8" y1="10" x2="16" y2="10" />
        <line x1="8" y1="14" x2="14" y2="14" />
      </svg>
    ),
    name: 'Recurring expense tracking',
    desc: 'Track truck payments, fuel, insurance, and tools. Built for trades workflows.',
  },
];

function Features() {
  const sectionRef = useSectionView('section_viewed_features');
  return (
    <section ref={sectionRef} style={{ backgroundColor: 'var(--sunk)', padding: '96px 24px' }}>
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
        <h2 style={{
          fontFamily: 'var(--font-serif)',
          fontSize: '36px',
          color: 'var(--ink)',
          textAlign: 'center',
          margin: '0 0 56px 0',
        }}>
          Everything you need to run the financial side
        </h2>

        <div className="feat-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '24px',
        }}>
          {FEATURES.map((feat, i) => (
            <div
              key={i}
              style={{
                backgroundColor: 'var(--card)',
                borderRadius: '14px',
                padding: '28px 32px',
                boxShadow: 'var(--sh-card)',
              }}
            >
              <div style={{
                width: '44px',
                height: '44px',
                borderRadius: '10px',
                backgroundColor: 'var(--signal-soft)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '16px',
              }}>
                {feat.icon}
              </div>
              <h3 style={{
                fontFamily: 'var(--font-serif)',
                fontSize: '18px',
                color: 'var(--ink)',
                margin: '0 0 8px 0',
              }}>
                {feat.name}
              </h3>
              <p style={{
                fontFamily: 'var(--font-sans)',
                fontSize: '14px',
                color: 'var(--slate)',
                lineHeight: 1.6,
                margin: 0,
              }}>
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .feat-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}

export default Features;
